import Slider from "../elements/Slider";

export default Slider;